@if (product) {
    <section class="section-product">
        <div class="product-breadcrumb">
            <breadcrumb></breadcrumb>
        </div>
        <div class="product-container">
            <ngx-json-ld [json]="jsonLd"></ngx-json-ld>
            @if (showSkinAnalyzer && isCelavive) {
                <skin-analyzer class="banner"></skin-analyzer>
            }

            @if (!isLoading) {
                @if (showLegacyPdp()) {
                    <ng-container *ngTemplateOutlet="legacyPdp"></ng-container>
                } @else {
                    <pdp-cms (cmsStatusChange)="onCmsStatus($event)" [product]="product"
                             [productGroup]="productGroup"></pdp-cms>
                }
            }
        </div>
    </section>
}

@if (showLegacyPdp() && showProductRecommend && !isLoading) {
    <featured-products-row-embed [products]="recommendedProducts" [titleTag]="'cart.recommended.products'"
                                 [showAiMessage]="showRecommendedProductsAiMessage"></featured-products-row-embed>
}

@if (notFound) {
    <section class="section-product">
        <div class="container productDetails">
            <div class="row">
                <div class="col-sm-12 productMeta">
                    <div class="clearfix">
                        <h3 class="text-center" translate="cart.product.missing.title"></h3>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 productMeta text-center">
                    <span translate="cart.product.missing.text"></span>
                </div>
            </div>
            @if (showAllProductsLink()) {
                <div class="row">
                    <div class="col-sm-12 productMeta text-center margin-top-32">
                        <a href="javascript:void(0)" (click)="openLocaleSwitcher()">
                            <h4 class="margin-top-4"><span translate="cart.product.select.new.market"></span></h4>
                        </a>
                        <span translate="cart.product.or"></span>
                        <a [routerLink]="[CATALOG_ROUTE, -1]"><h4 class="margin-top-4"><span translate="cart.landing.view.all.products"></span>
                            <i class="fa-regular fa-circle-play" aria-hidden="true"></i></h4></a>
                    </div>
                </div>
            }
        </div>
    </section>
}

<ng-template #legacyPdp>
    <div class="flex-col">
        <div class="product-images sticky-side">
            <div class="productMeta">
                <product-thumb-carousel [images]="product.productImages"
                                        [thumbSize]="'TH'"></product-thumb-carousel>
            </div>
        </div>
        <div class="product-descriptions productMeta">
            <div class="product-buy-box-container">
                @if (productNumber) {
                    <div class="product-number">
                        <span translate="cart.product.number"></span>{{productNumber}}
                    </div>
                }
                <h1 class="heading-2 product-name" automation-tag="productName"
                    [innerHTML]="productGroup.productDescription.name"></h1>
                <p class="short-description" [innerHTML]="product.productDescription.shortDescription"></p>

                <product-buy-box [productGroup]="productGroup" [product]="product"></product-buy-box>
            </div>

            @if (bodyBenefitTags?.length > 0) {
                <div class="page-section body-benefits">
                    <h2 class="heading-3" translate="cart.product.body.benefit"></h2>
                    <ul>
                        @for (tag of bodyBenefitTags; track tag.id) {
                            <li>
                                <img class="body-benefit"
                                     [src]="tag.imagePath" [alt]="tag.translationTag | translate" placement="bottom"
                                     attr.automation-tag="'bodyBenefit'-{{tag.id}}"/>
                                <span [translate]="tag.translationTag"></span>
                            </li>
                        }
                    </ul>
                </div>
            }

            @if (product?.productDescription?.longDescription) {
                <div class="page-section product-description">
                    <h2 class="heading-3" translate="cart.product.moreinformation"></h2>
                    <div class="productDetails">
                        <p class="description" [innerHTML]="product.productDescription.longDescription | safeHtml"
                           automation-tag="longDescription"></p>
                    </div>
                </div>
            }

            @if (product?.supplementalInfo?.path) {
                <div class="page-section supplement-facts">
                    <h2 class="heading-3" translate="cart.product.supplementfacts"></h2>
                    <p translate="cart.product.supplementfacts.learn.more"></p>
                    <a [href]="product.supplementalInfo.path" target="_blank"
                       translate="cart.product.supplementfacts.download"></a>
                </div>
            }
        </div>
    </div>
</ng-template>
